<template>
    <div class="change-phone-container">
    <change-box class="change-box">
      <template v-slot:content>
        <el-form ref="passwordFormRef"
               :model="passwordForm"
               :rules="passwordFormRules"
               label-width="120px"
               class="demo-ruleForm">
        <h3 class="title">
            找回密码
        </h3>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword"
                    placeholder="请输入新密码"
                    autocomplete="off"
                    clearable
                    show-password
                    size="medium"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码"
                      prop="comfirmPassword">
          <el-input v-model="passwordForm.comfirmPassword"
                    placeholder="请确认新密码"
                    autocomplete="off"
                    clearable
                    show-password
                    size="medium"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary"
                 size="medium"
                 @click="submitPasswordForm">确认</el-button>
      </template>
    </change-box>
  </div>
</template>

<script>
import changeBox from '@/components/public/changeBox'
export default {
  components: {
    'change-box': changeBox
  },
  data () {
      var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.passwordForm.comfirmPassword !== '') {
          this.$refs.passwordFormRef.validateField('comfirmPassword');
        }
        callback();
      }
    };
    var validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认密码'));
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
      return {
        passwordForm: {
            newPassword: '',
            comfirmPassword: ''
        },
        passwordFormRules: {
            newPassword: [
                { required: true, message: '请输入新密码', trigger: 'blur' },
                { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: '密码必须包含数字和字母，且在8-16位', trigger: 'blur' },
                { validator: validatePass, trigger: 'blur' }
            ],
            comfirmPassword: [
                { required: true, message: '请确认密码', trigger: 'blur' },
                { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: '密码必须包含数字和字母，且在8-16位', trigger: 'blur' },
                { validator: validateConfirmPass, trigger: 'blur' }
            ]
        }
      }
  },
  methods: {
    submitPasswordForm () {
      var param = {
        phoneNumber: this.$route.query.phoneNumber,
        verifyCode: this.$route.query.id,
        newPassword: this.passwordForm.newPassword,
        confirmPassword: this.passwordForm.comfirmPassword,
      }
      this.$refs.passwordFormRef.validate(valid => {
        if (valid) {
          this.$http.put('/api/services/inquiryApp/account/RestPasswordByPhone', param)
            .then(res => {
              this.$message.success('密码修改成功！')
              this.$router.push({path: `/home`})
            })
            .catch(err => {
              this.$message.error(err.data.error.message)
            })
        } else {
          this.$message.error('提交失败！')
        }
      })

    }
  }
}
</script>
<style lang="less" scoped>
.change-phone-container {
  background-color: #f4f4f4;
  height: 100%;
  padding-top: 50px;
  font-family: 'Source Han Sans CN';
}
.change-box {
  margin: 0 auto;
  text-align: center;
  .title {
    text-align: center;
    color: #2f343c;
    margin-bottom: 20px;
  }
  .demo-ruleForm{
      width: 400px;
      margin: 0 auto;
  }
}
</style>